import { TbUser, TbUsersGroup } from "react-icons/tb";
import z from "zod";

import { CommonStatusItem } from "@/types/global";

// Brightness1RoundedIcon
import { softColors } from "./colors";

export const createNotificationRecipientTypes = z.enum(["user", "permissionGroup"]);
export type CreateNotificationRecipientTypes = z.infer<typeof createNotificationRecipientTypes>;

export type NotificationRecipientItem = CommonStatusItem & {
    value: CreateNotificationRecipientTypes;
    label: string;
    color: "success" | "primary" | "error";
    labelDesc: string;
};
export const notificationRecipientTypes: NotificationRecipientItem[] = [
    {
        component: () => TbUser,
        ...softColors.indigo,
        tooltip: {
            title: "Kullanıcı",
            description: "Kullanıcı seçmek için tıklayınız.",
        },
        value: createNotificationRecipientTypes.enum.user,
        label: "Kullanıcı",
        labelDesc: "Kullanıcı seçmek için tıklayınız.",
        color: "primary",
    },
    {
        component: () => TbUsersGroup,
        ...softColors.green,
        tooltip: {
            title: "Yetki Grubu",
            description: "Yetki grubu seçmek için tıklayınız.",
        },
        value: createNotificationRecipientTypes.enum.permissionGroup,
        label: "Yetki Grubu",
        labelDesc: "Yetki grubu seçmek için tıklayınız.",
        color: "success",
    },
];
